import { render, staticRenderFns } from "./examinationQuestionEdit.vue?vue&type=template&id=17079570&scoped=true&"
import script from "./examinationQuestionEdit.vue?vue&type=script&lang=js&"
export * from "./examinationQuestionEdit.vue?vue&type=script&lang=js&"
import style0 from "./examinationQuestionEdit.vue?vue&type=style&index=0&id=17079570&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17079570",
  null
  
)

export default component.exports